import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { copyContent, emptyContent } from '../../Redux/Actions/formAction';
import { addContentInPlaylist } from '../../Redux/Actions/playlistAction';
import styles from './tab.module.css';
import Image from './tabviews/images/Image';
import Url from './tabviews/url/Url';
import Video from './tabviews/videos/Video';
import PdfTab from './tabviews/pdf/PdfTab';
import {  contentFlagOff, decreamentPaginatedContent, getContent, getPaginationContent, increamentPaginatedContent } from '../../Redux/Actions/contentAction';
import Pagination from '../../components/pagination/Pagination';
// import userService from '../../../controllers/service/userService';
const tabs = {
    image: Image,
    video: Video,
    url: Url,
    Pdf: PdfTab
}
function Tab(props) {
    const dispatch = useDispatch();
    // const {contentForm,isContentAvailable}=useSelector(state=>state.Form);
    const { content,content_stats,isContentLoaded, paginatedContentLength, paginatedContentPage,  paginatedContentLimit, contentForm, isContentAvailable, user } = useSelector(state => ({
        content: state.Content.content,
        isContentLoaded:state.Content.isContentLoaded,
        contentForm: state.Form.contentForm,
        isContentAvailable: state.Form.isContentAvailable,
        paginatedContentLength: state.Content.paginatedContentLength,
        paginatedContentPage: state.Content.paginatedContentPage,
        paginatedContentLimit: state.Content.paginatedContentLimit,
        user: state.User.user,
        content_stats:state.Content.content_stats
    }), shallowEqual);
    const [type, setType] = useState('image');
    const [isClicked, setIsClicked] = useState(false);
    const Component = tabs[type];
    useEffect(() => {
        isContentAvailable && dispatch(emptyContent())
    }, [])
    useEffect(() => {
        // socketRef.current.emit('leaving--connection')
        if(isContentLoaded){
            dispatch(copyContent(content));
            dispatch(contentFlagOff());
        }
    }, [isContentLoaded])
    useEffect(() => {
        if (isClicked && user.role=='user') {
            dispatch(getPaginationContent(user?._id, paginatedContentPage, paginatedContentLimit));
            setIsClicked(false);
        }
        if(content.length==0 && user.role=='user'){
            dispatch(getPaginationContent(user?._id, paginatedContentPage, paginatedContentLimit));
        }
        if((content.length==0 && user.role=='admin') || isClicked){
            dispatch(getContent(user?._id,paginatedContentPage,paginatedContentLimit));
            setIsClicked(false);
        }
        // return ()=>{
        //     dispatch(contentFlagOff())
        // }
    }, [user, paginatedContentPage, isClicked]);

    // const emitOfAddContent=(mac)=>{
    //     const id=setTimeout(() => {
    //         props.socketRef.current?.emit('content_added',{detail:{mac:mac}})
    //         clearTimeout(id);
    //     }, 2000);
    //   }
    const submitContent = () => {
        dispatch(addContentInPlaylist(contentForm));
        //    console.log(props.screenMac)
        //    if(props.screenMac!=="" || props.screenMac!==undefined){
        //    emitOfAddContent(props.screenMac);
        //    }
        props.close(false);
    }
    return (
        <>
            <div className={`${styles.tabContainer}`}>
                <div className={`${styles.tabHeader}`}>
                    <div className={`${styles.tabs}`}>
                        <button
                            className={`${styles.tabBtn} ${type === 'image' ? styles.tabActive : ''}`}
                            onClick={() => setType('image')}>Image</button>
                        <button
                            className={`${styles.tabBtn} ${type === 'video' ? styles.tabActive : ''}`}
                            onClick={() => setType('video')}>Video</button>
                        <button
                            className={`${styles.tabBtn} ${type === 'url' ? styles.tabActive : ''}`}
                            onClick={() => setType('url')}>URL</button>
                        <button
                            className={`${styles.tabBtn} ${type === 'Pdf' ? styles.tabActive : ''}`}
                            onClick={() => setType('Pdf')}>PDF</button>
                    </div>

                </div>
                <div className={`${styles.tabBody}`}>
                    <div className={`${styles.innerBody}`}>
                        <Component pId={props.pId} />
                    </div>
                </div>
                <div className={`${styles.tabFooter}`}>
                    <Pagination userLength={paginatedContentLength} userLimit={paginatedContentLimit} userPage={paginatedContentPage} onBack={(v) => {
                        dispatch(decreamentPaginatedContent())
                        setIsClicked(true)
                    }} onNext={(v) => {
                        dispatch(increamentPaginatedContent())
                        setIsClicked(true)
                    }} />
                    <button className='btn-cancel' onClick={() => props.close(false)}>close</button>
                    <button className='btn-save' onClick={submitContent}>Save</button>
                </div>
            </div>
        </>
    )
}

export default Tab